import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ConfigContext from '../../contexts/ConfigContext';

import styles from './PodTease.module.postcss';

function PodTease({ pod }) {
  const { imageBase } = useContext(ConfigContext);

  if (!pod.location) return null;

  const image = pod.location.photo
  ? `${imageBase}/${pod.location.photo}`
  : '/static/images/truck-placeholder.png';

  return (
    <div className={styles.PodTease}>
      <Link className="u-block" to={`/schedule/${pod.location.slug}`}>

        <img
          className={styles.PodTease_image}
          src={image}
          alt={pod.name}
          loading='lazy'
        />

        <div className={styles.PodTease_info}>
          <div className='u-strong u-mb05'>{pod.name}</div>
          <div>
            <div><img src='/static/images/icons/pin.svg' alt='Address'/></div>
            <div>{pod.location.address}</div>
          </div>
        </div>

      </Link>
    </div>
  );
}

PodTease.propTypes = {
  pod: PropTypes.object.isRequired,
};

export default PodTease;
